import { parseVideoLink } from '../validation/video-links.js';
/** Matches the `bio` length CHECK on `doer_profiles`. */
export const DOER_PROFILE_BIO_MAX = 1200;
/** Matches the `skills` cardinality CHECK on `doer_profiles`. */
export const DOER_PROFILE_SKILLS_MAX = 12;
/** One skill is a chip, not a sentence. */
export const DOER_PROFILE_SKILL_MAX_LENGTH = 40;
/**
 * The largest intro video we ask a browser to push through a signed PUT.
 *
 * A UX guard, NOT a control: a v4 signed upload URL carries no byte cap, so a
 * determined client can exceed this. Enforcing it for real needs a bucket
 * lifecycle/size rule or a signed *policy* upload, neither of which the GCS
 * client does today.
 */
export const DOER_INTRO_VIDEO_MAX_BYTES = 300 * 1024 * 1024;
/** Content types the upload endpoint will sign for an intro video. */
export const DOER_INTRO_VIDEO_CONTENT_TYPES = [
    'video/mp4', // the browser-universal one
    'video/quicktime', // what a Mac or iPhone recording is labelled
    'video/webm', // Chrome screen recordings
];
/**
 * How this doer's video plays, or null if it does not.
 *
 * Deliberately NOT `contentMediaPlayer`: every arm of `ContentMediaPlayer`
 * carries a `ContentMedia` row, and a doer's intro video is not a lesson in the
 * content library. Teaching that resolver about YouTube would also flip
 * existing `content_media` rows with `provider='youtube'` from unplayable to
 * playable, which changes which Foundations lessons are *required* — an
 * unrelated feature.
 */
export function doerIntroVideoPlayer(video) {
    if (!video)
        return null;
    if (video.kind === 'upload')
        return { kind: 'file', src: video.url };
    return video.embedUrl ? { kind: 'embed', src: video.embedUrl } : null;
}
/**
 * Build the resolved video from what is stored, for a client that has the raw
 * columns rather than the API's answer — the optimistic update in the editor,
 * which must agree with the response that follows it.
 */
export function toDoerIntroVideo(kind, url) {
    if (!kind || !url)
        return null;
    return {
        kind,
        url,
        embedUrl: kind === 'upload' ? null : (parseVideoLink(url)?.embedUrl ?? null),
    };
}
/** True when the doer has written nothing a founder could read. */
export function isDoerProfileEmpty(profile) {
    return (!profile.bio && profile.skills.length === 0 && !profile.introVideo && !profile.bookingUrl);
}
//# sourceMappingURL=doer-profile.js.map